// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"602be527","488":"c634631a","977":"f331a955"}[chunkId] + ".chunk.js";
};